import { Suspense, lazy } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import About from "@/pages/About";
import Consultation from "@/pages/Consultation";
import Contact from "@/pages/Contact";
import Home from "@/pages/Home";
import Industry from "@/pages/Industry";
import LegacyInternshipRedirect from "@/pages/LegacyInternshipRedirect";
import NotFound from "@/pages/NotFound";
import Privacy from "@/pages/Privacy";
import Programs from "@/pages/Programs";
import { getRouterBasename } from "@/lib/appBase";

// Programme pages carry long content (mentors, FAQs, batches), so they load as their own chunk.
const ProgramDetail = lazy(() => import("@/pages/ProgramDetail"));

function App() {
  return (
    <BrowserRouter basename={getRouterBasename()}>
      <Toaster position="top-center" richColors closeButton />
      <Suspense fallback={<div className="min-h-screen bg-white" aria-busy="true" />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/programs" element={<Programs />} />
          <Route path="/programs/:slug" element={<ProgramDetail />} />
          <Route path="/consultation" element={<Consultation />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          {/* The Locations page is switched off. Old links go to Contact, which now has the India map. */}
          <Route path="/locations" element={<Navigate to="/contact" replace />} />
          <Route path="/industries/:industryId" element={<Industry />} />
          <Route path="/internships/:categoryId" element={<LegacyInternshipRedirect />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;


